module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_c('div', {
    staticClass: "modal-backdrop"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-outer"
  }, [_c('div', {
    staticClass: "dialog-inner"
  }, [(_vm.closable) ? _c('a', {
    staticClass: "close iconfont",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_vm._v("")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-main"
  }, [(_vm.simple) ? _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    staticClass: "dialog-msg"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.link,
      "title": _vm.linkTitle
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v(_vm._s(_vm.btnText))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_vm._t("default")], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-66896998"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/modal.vue
// module id = 609
// module chunks = 1